import { render, staticRenderFns } from "./CloudBackground.vue?vue&type=template&id=56c9eae8&scoped=true"
import script from "./CloudBackground.vue?vue&type=script&lang=js"
export * from "./CloudBackground.vue?vue&type=script&lang=js"
import style0 from "./CloudBackground.vue?vue&type=style&index=0&id=56c9eae8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c9eae8",
  null
  
)

export default component.exports